import {
  actionTypes,
} from '../actions';

import type {
  UiAction,
  UiState,
} from '../types';

const initialState: UiState = {
  addFolderModal: false,
  renameFolderModal: false,
  fileUpload: {},
  fileDownload: {},
  uploadVideoModal: {
    isOpen: false,
    isLoaded: false,
  },
  uploadFileModal: {
    isOpen: false,
    isLoaded: false,
  },
  moveEntityToGroupModal: false,
  addGroupModal: false,
  addClientModal: false,
  forceArchiveClientsModal: false,
  upgradePlanModal: {
    isOpen: false,
  },
  currentEntityId: null,
  groupAvatarUrl: null,
  clientAvatarUrl: null,
  addEntityModal: {
    isOpen: false,
    resourceType: null,
  },
  addTemplateModal: {
    isOpen: false,
  },
  moveEntityModal: {
    isOpen: false,
  },
  addToLibrary: {
    isOpen: false,
    selectedItemId: null,
  },

  openedTooltips: [],

  confirmModal: {
    isOpen: false,
  },
  searchVideoModal: {
    isOpen: false,
  },
  currentCalendarDate: null,
  newWorkoutEventModal: {
    isOpen: false,
    startDate: new Date(),
  },
  activityLoggerModal: {
    isOpen: false,
    startDate: null,
  },
  dieRollSetupModal: {
    isOpen: false,
  },
  calendarSelectedUser: null,
  newWorkoutsEventUserSelected: null,
  bookmarks: {},
  selectedProgramWorkouts: {},
  workoutShouldBeSchedule: null,
  scheduleWorkoutModal: false,
  checkoutModal: {
    isOpen: false,
  },
  namespace: {
    settings: {
      color_schema: {},
    },
  },
  namespaceIsLoaded: false,
  exercisePickerIsOpen: false,
  openVideoModal: {
    isOpen: false,
  },
};

const mergeValues = (
  values,
  state,
) => (
  Object.keys(values).reduce((s, v) => ({
    ...s,
    [v]: values[v]?._merge ? ({ /* eslint-disable-line */
      ...state[v],
      ...values[v],
    }) : (
      values[v]
    ),
  }), {})
);

const ui = (
  state: UiState = initialState,
  action: UiAction,
) => {
  switch (action.type) {
    case actionTypes.SET_FILE_UPLOAD_STATE: {
      return {
        ...state,
        fileUpload: {
          ...state.fileUpload,
          [action.meta.key]: (state.fileUpload[action.meta.key]
            ? {
              ...state.fileUpload[action.meta.key],
              ...action.payload,
            }
            : action.payload
          ),
        },
      };
    }
    case actionTypes.SET_FILE_DOWNLOAD_STATE: {
      return {
        ...state,
        fileDownload: {
          ...state.fileDownload,
          [action.meta.key]: (state.fileUpload[action.meta.key]
            ? {
              ...state.fileDownload[action.meta.key],
              ...action.payload,
            }
            : action.payload
          ),
        },
      };
    }
    case actionTypes.CONFIRM_MODAL: {
      return {
        ...state,
        confirmModal: {
          isOpen: true,
          ...(action.modal
            ? {
              ...action.modal,
            }
            : {}
          ),
        },
      };
    }
    case actionTypes.SET_NAMESPACE_SETTINGS: {
      return {
        ...state,
        namespace: {
          ...state.namespace,
          settings: {
            ...state.namespace.settings,
            ...action.payload,
          }
        },
      };
    }
    case actionTypes.CANCEL_CONFIRM_MODAL: {
      return {
        ...state,
        confirmModal: {
          isOpen: false,
        },
      };
    }
    case actionTypes.MOVE_ENTITY_MODAL: {
      return {
        ...state,
        moveEntityModal: {
          isOpen: true,
          ...(action.modal
            ? {
              ...action.modal,
            }
            : {}
          ),
        },
      };
    }
    case actionTypes.CANCEL_MOVE_ENTITY_MODAL: {
      return {
        ...state,
        moveEntityModal: {
          isOpen: false,
        },
      };
    }
    case actionTypes.SEARCH_VIDEO_MODAL: {
      const {
        modal,
        scope,
        query,
      } = action;
      return {
        ...state,
        searchVideoModal: {
          isOpen: true,
          scope,
          query,
          ...(modal
            ? {
              ...modal,
            }
            : {}
          ),
        },
      };
    }
    case actionTypes.ASSIGN_SEARCH_VIDEO_MODAL:
    case actionTypes.CANCEL_SEARCH_VIDEO_MODAL: {
      return {
        ...state,
        searchVideoModal: {
          isOpen: false,
        },
      };
    }
    case actionTypes.OPEN_EXERCISE_PICKER: {
      return {
        ...state,
        exercisePickerIsOpen: true,
      };
    }
    case actionTypes.SELECT_EXERCISE_PICKER:
    case actionTypes.CANCEL_EXERCISE_PICKER: {
      return {
        ...state,
        exercisePickerIsOpen: false,
      };
    }
    case actionTypes.SWITCH_BOOKMARK_WORKOUT: {
      return {
        ...state,
        bookmarks: {
          ...state.bookmarks,
          [action.payload]: !state.bookmarks[action.payload],
        },
      };
    }
    case actionTypes.SET_UI_STATE: {
      const {
        keyOrRootValues,
        maybeValues,
      } = action.payload;
      const [
        values,
        key,
      ] = (
          maybeValues === undefined
            ? [
              keyOrRootValues,
              null,
            ]
            : [
              maybeValues,
              keyOrRootValues,
            ]
        );
      return {
        ...state,
        ...(
          key
            ? ({
              [key]: {
                ...state[key],
                ...mergeValues(
                  values,
                  state[key],
                ),
              },
            })
            : (
              mergeValues(
                values,
                state,
              )
            )
        ),
      };
    }
    default:
      return state;
  }
};

export default ui;
